(function(){
 'use strict';
 if(window.ATV06TrackingReady)return;
 window.ATV06TrackingReady=true;
 if(window.Shopify?.designMode||window.Shopify?.theme?.role!=='main'||new URLSearchParams(location.search).has('preview_theme_id')||navigator.doNotTrack==='1'||navigator.globalPrivacyControl===true)return;
 if(/\/pages\/(admin|platform-admin|transaction-approvals|partners-approval|project-disputes)/.test(location.pathname))return;
 const base='https://xjqxifpxjvqrojhkmecg.supabase.co/rest/v1/rpc/at_v06_store_event';
 const key='sb_publishable_S23mhfstuHPOdKFPGqFxVg_SiIaTOA4';
 let started=false;
 function consent(){return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;}
 function identity(){
  try{
   let visitor=localStorage.getItem('at_v06_visitor');
   if(!/^[0-9a-f-]{36}$/i.test(visitor||'')){visitor=crypto.randomUUID();localStorage.setItem('at_v06_visitor',visitor);}
   let session=JSON.parse(sessionStorage.getItem('at_v06_visit')||'null');
   const newSession=!session||!Number.isFinite(session.last)||Date.now()-session.last>1800000;
   if(newSession)session={id:crypto.randomUUID()};
   session.last=Date.now();sessionStorage.setItem('at_v06_visit',JSON.stringify(session));
   return{visitor,session:session.id,newSession};
  }catch{return null;}
 }
 function source(el){if(el?.closest('[data-v06-home]'))return'home';if(/\/products\//.test(location.pathname))return'product';if(/\/collections\//.test(location.pathname))return'catalog';return'other';}
 function send(event,target,el){
  if(!consent())return;
  const ids=identity();if(!ids)return;
  function record(kind,path){fetch(base,{method:'POST',headers:{apikey:key,'Content-Type':'application/json'},body:JSON.stringify({p_visitor:ids.visitor,p_session:ids.session,p_event:kind,p_target:path,p_source:source(el),p_preview:false}),keepalive:true}).catch(()=>{});}
  if(ids.newSession&&event!=='page_view')record('page_view',location.pathname);
  record(event,target);
 }
 function start(){if(started||!consent())return;started=true;send('page_view',location.pathname,null);}
 document.addEventListener('click',function(e){const a=e.target.closest?.('a[href]');if(!a)return;const u=new URL(a.href,location.origin);if(u.origin!==location.origin||!u.pathname.includes('/products/'))return;const target=u.pathname.slice(u.pathname.indexOf('/products/'));send('product_click',target,a);if(a.closest('.at-v06-offers'))send('offer_click',target,a);},true);
 document.addEventListener('visitorConsentCollected',start);
 if(window.Shopify?.customerPrivacy)start();
 else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)start();});
})();
